import React, { useEffect, useState } from "react";
import { postAPICall, s3url } from "../Api/Api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { MdDragIndicator } from "react-icons/md";
import { FaVideo } from "react-icons/fa6";
import "./Style.css";
import GlobalPopup from "../GlobalComponents/GlobalPopup";
import { useLoader } from "../GlobalComponents/Loader";
export default function PlaylistLibraryGrid(props) {
  const [PlaylistLibrary, setPlaylistLibrary] = useState([]);
  const [location, SetVideoPath] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [MediaLocation, setMediaLocation] = useState("");
  const [selectedVideoSrc, setSelectedVideoSrc] = useState("");
  const [ReorderSchId, setReorderSchId] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRowValue, setSelectedRowValue] = useState(true);
  const { showLoader, hideLoader } = useLoader();
  
  useEffect(() => {
    props?.selectednewid != "" && fetchPlaylistLibrary();
  }, [props]);
  const fetchPlaylistLibrary = async () => {
    showLoader();
    let stringconversion = props?.selectednewid.toString() || "";
    const requestBody = {
      categoryId: stringconversion,
    };
    const response = await postAPICall(
      "api/PlayLists/ScheduleMediaList",
      requestBody
    );
    hideLoader()
    setPlaylistLibrary(response?.data || []);
  };
  //Video Play event
  // const handlePreviewClick = (rowData) => {
  //   setSelectedVideoSrc(rowData.MediaLocation);
  //   if (rowData !== undefined) {
  //     const Videolocation = s3url + rowData.MediaLocation;
  //     SetVideoPath(Videolocation);
  //     setShowDialog(true);
  //     setTimeout(() => {
  //       const videoElement = document.getElementById("videoplay");
  //       if (videoElement) {
  //         videoElement.play();
  //       }
  //     }, 500);
  //   }
  // };
  const handlePreviewClick = (rowData) => {
      if (rowData !== undefined) {
        // Set the video source URL
        setSelectedVideoSrc(rowData.MediaLocation);
  
        // Construct the full video URL
        const videoLocation = s3url + rowData.MediaLocation;
        SetVideoPath(videoLocation);
  
        // Show the dialog for video preview
        setShowDialog(true);
  
        // Ensure the video element is properly loaded and ready
        const videoElement = document.getElementById("videoplay");
  
        if (videoElement) {
          videoElement.src = videoLocation; // Set video source
          videoElement.load(); // Ensure the video is reloaded before playing
  
          // Play the video after it has loaded
          videoElement.oncanplay = () => {
            videoElement.play().catch((error) => {
              console.error("Error playing video:", error);
            });
          };
        }
      }
    };
  //Set play icon
  const previewIconTemplate = (rowData) => {
    return (
      <Button
        icon={<FaVideo />}
        id="playicon"
        className="p-button p-button-text"
        onClick={() => handlePreviewClick(rowData)}
      ></Button>
    );
  };
  //Row Select to get value
  const HandleRowSelect = (e) => {
    setSelectedRowValue(e.value);
    setMediaLocation(e.value.MediaLocation);
  };
  //Kess Press event
  // const HandleKeyDown = (e) => {
  //   if (e.code === "Enter") {
  //     const Videolocation = s3url + MediaLocation;
  //     SetVideoPath(Videolocation);
  //     setShowDialog(true);
  //     setTimeout(() => {
  //       const videoElement = document.getElementById("videoplay");
  //       if (videoElement) {
  //         videoElement.play();
  //       }
  //     }, 500); // Adjust delay as needed
  //   } else if (e.code === "Escape") {
  //     setShowDialog(false);
  //   }
  // };
    const HandleKeyDown = (e) => {
      debugger
      if (e.code === "Enter") {
        const Videolocation = s3url + MediaLocation;
        SetVideoPath(Videolocation);
        setShowDialog(true);
    
        setTimeout(() => {
          const videoElement = document.getElementById("videoplay");
          
          // Ensure the video element is still present and ready
          if (videoElement && videoElement.readyState >= 3) {
            videoElement.play().catch(error => {
              console.error("Error playing video: ", error);
            });
          } else {
            console.error("Video element is not ready to play.");
          }
        }, 500); // Adjust delay as needed
    
      } else if (e.code === "Escape") {
        setShowDialog(false);
      }
    };
  const handleCloseDialog = () => {
    setShowDialog(false);
  };
  //Drag Start to get drag value and stored Usestate
  const onDragStart = (e, rowData) => {
    setReorderSchId(rowData.SchHdrID);
    props.onDragStartValue(rowData);
    localStorage.setItem("rowData", rowData);
  };
  const filteredData = PlaylistLibrary?.filter(
    (item) =>
      item.MediaName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.MediaDuration.toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <div>
      <div id="PlaylistLibraryGridHeaderCard">
        <InputText
          id="AccountGroupSearch"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
          style={{ width: "170px" }}
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          title="Search"
          className="p-button-primary"
        />
      </div>
      <DataTable
        value={filteredData}
        className="p-datatable_PlaylistLibraryGrid"
        scrollable
        scrollHeight="68vh"
        onSelectionChange={HandleRowSelect}
        onKeyDown={HandleKeyDown}
        selectionMode={"single"}
        rowClassName={(rowData) =>
          selectedRowValue && selectedRowValue.MediaID === rowData.MediaID
            ? "selected-row"
            : ""
        }
      >
        <Column
          hidden={props.HideDragIcon ? true : false}
          body={(rowData) => (
            <div draggable onDragStart={(e) => onDragStart(e, rowData)}>
              <Button
                id="PlayListSchListDragIcon"
                icon={<MdDragIndicator />}
                title="Drag"
              ></Button>
            </div>
          )}
        ></Column>
        <Column
          field="MediaName"
          header="MediaName"
          style={{ width: "auto", border: "1px slid black" }}
          className="text-ellipsis  column-border"
          body={(rowData) => {
            return <span title={rowData.MediaName}>{rowData.MediaName}</span>;
          }}
        />
        <Column
          field="MediaDuration"
          header="Duration"
          sortable
          className="column-border"
          body={(rowData) => {
            return (
              <span title={rowData.MediaDuration}>{rowData.MediaDuration}</span>
            );
          }}
        />
        <Column
          field="MediaLocation"
          header="MediaLocation"
          sortable
          hidden
          className="column-border"
        />
        <Column
          field="MediaSizeMB"
          header="SizeMB"
          sortable
          className="column-border"
        />
        <Column field="Name" header="Name" sortable className="column-border" />

        <Column
          header="Preview"
          width={100}
          allowFiltering={false}
          allowSorting={false}
          body={previewIconTemplate}
        />
      </DataTable>
      <GlobalPopup
        title={"Video Preview"}
        visible={showDialog}
        onHide={handleCloseDialog}
        footerButtons={
          <div>
            <video id="videoplay" controls tabIndex="0">
              <source src={location} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        }
        Popupwidth={800}
        Popupheight={500}
      />
    </div>
  );
}
